import { combineReducers } from "redux";

import vacations from "./vacations";

export default combineReducers({
  vacations,
});
